import { UntypedFormControl } from "@angular/forms";

export function greaterThanOrEqualToZero(control: UntypedFormControl) { 
    const num = control.value; 
    if(num < 0){
        return {error: "Value must be greater than or equal to 0"};
    }
    return null;
}